/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Group_Discount_LabelInputs */

const vi_customer_group_discount_label = /** @type {(inputs: Customer_Group_Discount_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiết khấu (%)`)
};

/**

* @param {Customer_Group_Discount_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_group_discount_label = /** @type {((inputs?: Customer_Group_Discount_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Group_Discount_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_group_discount_label(inputs)
});